type PrivilegeAccess = Record<string, boolean>;

export interface PermissionMap {
  [permissionName: string]: PrivilegeAccess;
}

export function buildPermissionMap(user: any): PermissionMap {
  const rolePrivileges = user?.role?.rolePrivileges ?? [];

  return rolePrivileges.reduce((acc: PermissionMap, rp: any) => {
    const permissionName = rp?.privilege?.permissions;
    const updatedAccess: PrivilegeAccess = rp?.updatedAccess ?? {};

    if (permissionName) {
      acc[permissionName] = updatedAccess;
    }

    return acc;
  }, {});
}

export function hasAnyAccess(map: PermissionMap, permissionName: string): boolean {
  const access = map[permissionName];
  if (!access) return false;
  return Object.values(access).some(Boolean);
}

export function can(map: PermissionMap, permissionName: string, action: string): boolean {
  return !!map[permissionName]?.[action];
}

// New helper
export function hasReadAccess(map: PermissionMap, permissionName: string): boolean {
  return !!map[permissionName]?.read;
}

// Ordered list — first match wins
const ROUTE_PRIORITY = [
  { permissionKey: 'Dashboard', href: '/dashboard' },
  { permissionKey: 'Users', href: `/members/4` },
  { permissionKey: 'SportAnalysis', href: '/sport-analysis' },
  { permissionKey: 'MyReport', href: '/bet-list' },
  { permissionKey: 'EventManagement', href: '/event-management' },
  { permissionKey: 'CasinoControl', href: '/casino-management' },
  { permissionKey: 'Transaction', href: '/requests' },
  { permissionKey: 'ContentManagement', href: '/content-management' },
  { permissionKey: 'Bonus', href: '/bonus/policy-management' },
  { permissionKey: 'Roles Privileges', href: '/roles-and-privileges' },
  { permissionKey: 'Account Statement', href: '/rolewise-account-statement' },
  { permissionKey: 'Change Password', href: '/settings' },
  { permissionKey: 'Operation logs', href: '/operation-logs' },
];

export function getDefaultRoute(user: any, isOwner: boolean): string {
  if (isOwner) return '/dashboard';

  const permissionMap = buildPermissionMap(user);

  const firstAllowed = ROUTE_PRIORITY.find((route) =>
    hasReadAccess(permissionMap, route.permissionKey)
  );

  return firstAllowed?.href ?? '/dashboard';
}
